<template>
  <div class="row mass-stats-row">
    <div class="col-lg-3">
      <div class="widget style1 navy-bg mass-stat-card mass-stat-card-primary">
        <div class="row vertical-align">
          <div class="col-xs-3">
            <span class="mass-stat-icon"><i class="fa fa-cubes"></i></span>
          </div>
          <div class="col-xs-9 text-right">
            <span>{{ labels.configurations }}</span>
            <h2 class="font-bold">{{ configurationsCount }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="widget style1 lazur-bg mass-stat-card mass-stat-card-success">
        <div class="row vertical-align">
          <div class="col-xs-3">
            <span class="mass-stat-icon"><i class="fa fa-check-square-o"></i></span>
          </div>
          <div class="col-xs-9 text-right">
            <span>{{ labels.selected }}</span>
            <h2 class="font-bold">{{ selectedCount }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="widget style1 yellow-bg mass-stat-card mass-stat-card-warning">
        <div class="row vertical-align">
          <div class="col-xs-3">
            <span class="mass-stat-icon"><i :class="{'fa-spin': runningCount > 0}" class="fa fa-spinner"></i></span>
          </div>
          <div class="col-xs-9 text-right">
            <span>{{ labels.running }}</span>
            <h2 class="font-bold">{{ runningCount }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="widget style1 red-bg mass-stat-card mass-stat-card-danger">
        <div class="row vertical-align">
          <div class="col-xs-3">
            <span class="mass-stat-icon"><i class="fa fa-flag-checkered"></i></span>
          </div>
          <div class="col-xs-9 text-right">
            <span>{{ labels.finished }}</span>
            <h2 class="font-bold">{{ finishedCount }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    labels: {
      type: Object,
      required: true,
    },
    configurationsCount: {
      type: Number,
      required: true,
    },
    selectedCount: {
      type: Number,
      required: true,
    },
    runningCount: {
      type: Number,
      required: true,
    },
    finishedCount: {
      type: Number,
      required: true,
    },
  },
};
</script>
